import { createContext } from 'react'

export const ModularContext = createContext({})
export const ModularProvider = ModularContext.Provider
